import React from 'react'
import { STATUS_CONFIG } from './StatusConfig'
const SearchStatus = () => {
  return (

    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {Object.entries(STATUS_CONFIG).map(([key, value]) => (
        <div
          key={key}
          className="flex flex-col gap-2 rounded-lg border border-gray-200 p-4 bg-white"
        >
          {/* Status Badge */}
          <span
            className={`w-fit inline-flex items-center px-3 py-1 text-sm font-medium rounded-full border ${value.color}`}
          >
            {value.label}
          </span>

          {/* Description */}
          <p className="text-sm text-gray-600">
            {value.description}
          </p>
        </div>
      ))}
    </div>
  )

}

export default SearchStatus